import { formatGBP } from '../../lib/currency';
import './offerActionBar.css';

/**
 * The one set of answers to an offer: Decline or Accept.
 *
 * Rendered by both the Home card and the full-screen offer, so the two can
 * never drift apart again: on 2026-09-06 the screen and the card had two
 * vocabularies for one decision. One component, one vocabulary.
 *
 * There is no counter-offer: the client books at the price InGo quoted, and a
 * rider takes the job at that price or lets it pass. The money shown is the
 * offer's own figure.
 */
export default function OfferActionBar({ offer, busy, disabled, onAccept, onDecline }) {
  const off = Boolean(busy || disabled);

  return (
    <div className="ofa">
      <div className="ofa__row" role="group" aria-label="Answer this offer">
        <button type="button" className="ofa__btn ofa__btn--decline" disabled={off} onClick={onDecline}>
          {busy ? '…' : 'Decline'}
        </button>
        <button type="button" className="ofa__btn ofa__btn--accept" disabled={off} onClick={onAccept}>
          {busy ? '…' : `Accept ${formatGBP(offer.amount)}`}
        </button>
      </div>
    </div>
  );
}
